// extracted by mini-css-extract-plugin
module.exports = {"container":"results-list_container__2WjpN"};